import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";
import { tokenPayload } from "./components/redux/actions/userAction";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

import Zample from "./components/pages/zample";

import login from "./components/pages/register/login/login";
import Signup from "./components/pages/register/signup/signup";

import Origin from "./components/pages/origin/origin";
import Register from "./components/pages/origin/matchSetting/roomRegister/roomRegister";
import MatchSetting from "./components/pages/origin/matchSetting/matchSetting";

import ChatRoom from "./components/pages/board/chat/chatRoom";
import VideoRoom from "./components/pages/board/video/VideoRoom";
// import videoConRoom from "./components/pages/videoConRoom03";

import Board from "./components/pages/board/board";
import Chess from "./components/pages/board/chess/chess";
import ChessRole from "./components/pages//board/chess/chessRole/chessRole";
// import Range from "./components/pages/range";

import Rank from "./components/pages/rank/rank";
import Watch from "./components/pages/watch/watch";
import Rules from "./components/pages/rules/rules";

function App() {
	return (
		<React.Fragment>
			<BrowserRouter>
				<Switch>
					<Route exact path="/item" component={Zample} />

					<Route exact path="/" component={Origin} />
					<Route exact path="/login" component={login} />
					<Route exact path="/signup" component={Signup} />

					<Route exact path="/chat/register" component={Register} />

					<Route exact path="/ChatRoom/:roomId" component={ChatRoom} />
					<Route exact path="/VideoRoom/:roomId" component={VideoRoom} />

					<Route exact path="/board/setting" component={MatchSetting} />
					<Route exact path="/board/:roomId" component={Board} />
					<Route exact path="/chess" component={Chess} />

					<Route exact path="/rank" component={Rank} />
					<Route exact path="/watch" component={Watch} />
					<Route exact path="/rules" component={Rules} />

					{/* <Route exact path="/" component={ChessRole} /> */}
					{/* <Route exact path="/" component={Chess} /> */}
					{/* <Route exact path="/" component={Setting} /> */}
				</Switch>
			</BrowserRouter>
		</React.Fragment>
	);
}

export default App;
